import { createValidationPlugin } from '@formkit/validation';

// Based off https://github.com/formkit/formkit/blob/master/packages/rules/src/confirm.ts

const hasConfirmCaseInsensitive = /_confirmCaseInsensitive$/;

export const confirmCaseInsensitivePlugin = createValidationPlugin({
  confirmCaseInsensitive: (node, address?) => {
    if (!address) {
      address = hasConfirmCaseInsensitive.test(node.name)
        ? node.name.replace(hasConfirmCaseInsensitive, '')
        : `${node.name}_confirmCaseInsensitive`;
    }
    const foreignValue: string | undefined | null = node.at(address)?.value as string | undefined | null;
    return (node.value as string).toLowerCase() === foreignValue?.toLowerCase();
  },
});
